var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5 2H6.5C5.96957 2 5.46086 2.21071 5.08579 2.58579C4.71071 2.96086 4.5 3.46957 4.5 4V7H2.5V9H4.5V11H2.5V13H4.5V15H2.5V17H4.5V20C4.5 20.5304 4.71071 21.0391 5.08579 21.4142C5.46086 21.7893 5.96957 22 6.5 22H21.5C21.7652 22 22.0196 21.8946 22.2071 21.7071C22.3946 21.5196 22.5 21.2652 22.5 21V3C22.5 2.73478 22.3946 2.48043 22.2071 2.29289C22.0196 2.10536 21.7652 2 21.5 2ZM13.5 4.999C15.148 4.999 16.5 6.35 16.5 7.999C16.4971 8.79385 16.1801 9.55533 15.6182 10.1175C15.0562 10.6796 14.2948 10.9968 13.5 11C11.853 11 10.5 9.647 10.5 7.999C10.5 6.35 11.853 4.999 13.5 4.999ZM19.5 18H7.5V17.25C7.5 15.031 10.205 12.75 13.5 12.75C16.795 12.75 19.5 15.031 19.5 17.25V18Z",
    fill: "#1A1003",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.b8f50b8a9e63abed0c535001c592abaa.svg";
export { ForwardRef as ReactComponent };